export enum UIButtons {
    Settings = "settings",
    FeatureBuy = "feature",
    Bet = "bet",
    PayTable = "paytable",
    BetUp =  "betUp",
    BetDown =  "betDown",
    MaxBet =  "maxBet",
    AutoPlay =  "auto",
    Spin =  "spin",
    Stop =  "stop",
    Skip =  "skip",
    StakeMenu =  "stake_menu",
    Gamble =  "gamble",
    Collect =  "collect",
    Home =  "home",
    Info =  "info",
    Sound =  "sound",
    SoundMuted =  "sound_muted",
    StopAutoplay =  "stopAuto",
    QuickSpin = "quickSpin",
    Turbo = "turbo",
    Jackpot = "jackpot"
};
